import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { QuestionComponent } from '../question.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrollService } from '../scroll.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentViewerModalComponent } from '../modals/document-viewer-modal.component';

@Component({
  selector: `crds-question-doc-viewer`,
  template: `
    <div *ngIf="show" [formGroup]="form" class="view-document">
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key"
        >{{ question.label }}:
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question" [message]="question.errorMessage"></crds-form-error>
      </label>
      <button (click)="showDocument()" type="button" class="btn btn-primary view-document-button" #viewDocumentButton>
        <span>{{ question.buttonLabel || 'View document' }}</span>
        <i class="material-icons button-icon">{{ question.buttonIcon || 'description' }}</i>
      </button>
      <ngx-spinner name="document-loader" bdColor="rgba(51, 51, 51, 0.8)" size="large" type="line-scale"> </ngx-spinner>
    </div>
  `,
  styles: [
    `
      .material-icons {
        color: #ffffff;
      }
      .view-document {
        padding-bottom: 0.6rem;
      }
      .view-document-button > span {
        line-height: 2rem;
        padding-right: 0.5rem;
        vertical-align: middle;
      }
      .view-document-button > .material-icons {
        vertical-align: middle;
      }
    `
  ]
})
export class DocumentViewerQuestionComponent extends QuestionComponent implements OnInit {
  @ViewChild('viewDocumentButton') input;

  constructor(
    private spinnerService: NgxSpinnerService,
    private scrollService: ScrollService,
    private modalService: NgbModal
  ) {
    super();
  }

  ngOnInit() {
    this.scrollService.scrollObservable.subscribe(documentId => {
      if (documentId === this.question.key) {
        this.input.nativeElement.scrollIntoView();
      }
    });
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get value() {
    return this.form.get(this.question.key).value;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ? this.showIf : true;
    return (
      (this.question.showIfPopulated !== true || this.form.get(this.question.key).value) &&
      showIfQuestionPopulated &&
      this.question.show !== false
    );
  }

  showDocument() {
    const documentViewerRef = this.modalService.open(DocumentViewerModalComponent);
    documentViewerRef.componentInstance.url = this.value;
    documentViewerRef.componentInstance.config = {
      title: this.question.buttonLabel,
      confirm: 'Close'
    };
  }
}
